export default "__VITE_ASSET__19ad1f13__"